import {RouteObject} from "react-router";
import {ErrorPage} from "@src/Layers/ErrorLayer/ErrorPage.tsx";
import {MainMenu} from "@src/Pages/SettingsPage/MainMenu.tsx";
import {Outlet} from "react-router-dom";
import {FAQPage} from "@src/Pages/SettingsPage/FAQPage.tsx";
import { BackButtonViewPage } from "@src/CommonComponents/HeaderWithBackButton/HeaderWithBackButton.tsx";
import {MDDispatcher} from "@src/Pages/SettingsPage/MDDispatcher.tsx";
import terms from "@src/terms.md?raw"
import privacy from "@src/privacy.md?raw"
import {StatementList} from "@src/Pages/Statement/StatementList.tsx";
import {StatementView} from "@src/Pages/Statement/StatementView.tsx";


export const path = 'settings'

export const settingsPageRoute: RouteObject = {
    path,
    element: <Outlet />,
    errorElement: <ErrorPage header={false}/>,
    children: [
        {
            path: "",
            element: <BackButtonViewPage title={"Menu"}><MainMenu /></BackButtonViewPage>,
        },
        {
            path: 'faq',
            element: <BackButtonViewPage title={"FAQ"}><FAQPage /></BackButtonViewPage>,
            errorElement: <ErrorPage header={false}/>
        },
        {
            path: 'terms',
            element: <BackButtonViewPage title={"Terms of service"}><MDDispatcher file={terms} /></BackButtonViewPage>,
            errorElement: <ErrorPage header={false}/>
        },
        {
            path: 'policy',
            element: <BackButtonViewPage title={"Privacy Policy"}><MDDispatcher file={privacy} /></BackButtonViewPage>,
            errorElement: <ErrorPage header={false}/>
        },
        {
            path: "salary",
            element: <BackButtonViewPage title={"My salary"}><StatementList /></BackButtonViewPage>,
            errorElement: <ErrorPage header={false}/>
        },
        {
            path: "salary/:statementId",
            element: <BackButtonViewPage title={"Pay slip"}><StatementView /></BackButtonViewPage>,
            errorElement: <ErrorPage header={false}/>
        }
    ]
}